module.exports = __webpack_public_path__ + "img/中国农业银行.a5618fea.png";